import React, { useState, useEffect } from 'react';
import Header from './Header'; // Import Header component
import Sidebar from './Sidebar'; // Import Sidebar component
import './DoctorHistory.css'; // Ensure you create this CSS file for styling
import './Dashboard.css'; // Ensure you create this CSS file for styling
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {axiosInstance} from './helper/axiosConfig';
import { Link, useLocation } from 'react-router-dom'; // Import Link and useLocation for navigation
import { faArrowLeft, faChevronLeft, faChevronRight, faCamera, faPrint, faShareAlt, faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'; // Import icons

// Function to generate random colors for avatars
const getRandomColor = () => {
  const colors = ['#f56565', '#68d391', '#63b3ed', '#ed8936', '#f6ad55', '#9f7aea', '#48bb78', '#4299e1'];
  return colors[Math.floor(Math.random() * colors.length)];
};

// Utility function to get the first letter of the doctor's name
const getAvatarLetter = (name) => {
  return name ? name.charAt(0).toUpperCase() : '?';
};

function DoctorHistory() {
  const [doctorHistory, setDoctorHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const rowsPerPage = 10; // Set rows per page for pagination
  const [totalPages, setTotalPages] = useState(1); // Track total pages
  const [searchTerm, setSearchTerm] = useState(''); // State for search term

  const currentDate = new Date();
  const tenYearsAgo = new Date(currentDate.setFullYear(currentDate.getFullYear() - 10)); // Calculate the date 10 years ago

  const [dateRange, setDateRange] = useState({
    startDate: tenYearsAgo,
    endDate: new Date(),
  });

  // Fetch doctor history data with pagination and filtering
  const fetchDoctorHistory = async (page, searchTerm, dateRange) => {
    try {
      const response = await axiosInstance.get(`/api/doctor-all/`, {
        params: {
          page: page, // Pass the current page
          limit: rowsPerPage, // Pass the rows per page
          search: searchTerm, // Pass the search term
          startDate: dateRange.startDate.toISOString(), // Pass the start date
          endDate: dateRange.endDate.toISOString(), // Pass the end date
        },
      });
      setDoctorHistory(response.data.results); // Assuming the API returns a `results` array
      setTotalPages(Math.ceil(response.data.total / rowsPerPage)); // Assuming the API returns a `total` count of doctors
    } catch (error) {
      console.error('Error fetching doctor history:', error);
      setError('Failed to fetch doctor history.');
    } finally {
      setLoading(false); // Stop the loading state
    }
  };

  useEffect(() => {
    fetchDoctorHistory(currentPage, searchTerm, dateRange);
  }, [currentPage, searchTerm, dateRange]);

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // New function to handle search and date changes
  const handleSearch = (term) => {
    setSearchTerm(term);
    setCurrentPage(1); // Reset to first page on search
  };

  const handleDateChange = (ranges) => {
    setDateRange({
      startDate: ranges.startDate,
      endDate: ranges.endDate,
    });
    setCurrentPage(1); // Reset to first page on date change
  };

  const handleDeleteDoctor = async (doctorId) => {
    const r = window.confirm("Are you sure to remove the doctor?");
    if(r){
      try {
        await axiosInstance.delete(`/api/doctor/${doctorId}`);
        // Handle successful deletion, e.g., update the list of appointments, show a success message
        console.log('Patient deleted successfully');
        fetchDoctorHistory(currentPage, searchTerm, dateRange);
        //history('/appoinment-history'); // Redirect after successful creation
      } catch (error) {
        console.error('Error deleting doctor:', error);
        // Handle error, e.g., show an error message to the user
      }
    }
  };


  return (
    <div className="dashboard-container">
      <Sidebar /> {/* Sidebar component */}
      <div className="dashboard-main">
        <Header onSearch={handleSearch} onDateChange={handleDateChange} /> {/* Pass handlers to Header */}
        <div className="content-box">
          <div className="doctor-history-container">
            <div className="header-container">
              <h1>Doctor’s List</h1>
              <button className="btn print-btn">
                <Link to="/create-doctor/"> + Add Doctor</Link>
              </button>
            </div>

            {loading ? (
              <p>Loading...</p>
            ) : error ? (
              <p>{error}</p>
            ) : (
              <>
                {doctorHistory && doctorHistory.length > 0 && (
                <>
                  <table className="doctor-history-table">
                    <thead>
                      <tr>
                        <th>Doctor's Name</th>
                        <th>Speciality</th>
                        <th>BMDC Number</th>
                        <th>Mobile Number</th>
                        <th>Email</th>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                      {doctorHistory.map((doctor) => (
                        <tr key={doctor.id}>
                          <td>
                            {/* Avatar circle */}
                            <div className="avatar-circle" style={{ backgroundColor: !doctor.profile_pic ? getRandomColor() : 'transparent' }}>
                              {doctor.profile_pic ? (
                                <img
                                      src={`${process.env.REACT_APP_AXIOS_BASE_URL}${doctor.profile_pic}`} // Concatenating the base URL and profile_pic
                                      alt={doctor.full_name} className="avatar-circle"
                                    // Ensure the profile-pic class is styled in your CSS
                                    />

                              ) : (
                                <span className="initials">{getAvatarLetter(doctor.full_name)}</span>
                              )}
                            </div>

                            {doctor.full_name}
                          </td>
                          <td>{doctor.speaciality}</td>
                          <td>{doctor.bmdc_number}</td>
                          <td>{doctor.mobile_number}</td>
                          <td>
                          {doctor.email}
                          </td>
                          <td>
                            <Link to={`/update-doctor/${doctor.id}`} >
                              <FontAwesomeIcon
                                icon={faEdit}
                                className="picker-icon"
                              />
                            </Link>
                          </td>
                          <td>{doctor.has_prescription}
                              { !doctor.has_prescription && ( // Call the function here
                                  <a onClick={() => handleDeleteDoctor(doctor.id)} className="trash-icon">
                                    <FontAwesomeIcon icon={faTrash} className="picker-icon" />
                                  </a>
                              )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="pagination">
                  {totalPages > rowsPerPage && (
                    <>
                      {currentPage > 1 && (
                        <button onClick={() => handlePageChange(currentPage - 1)} className="ltgt">&lt;</button>
                      )}
                      {Array.from({ length: totalPages }, (_, index) => {
                        if (index + 1 === currentPage || index + 1 === 1 || index + 1 === totalPages || Math.abs(currentPage - (index + 1)) <= 1) {
                          return (
                            <button
                              key={index + 1}
                              onClick={() => handlePageChange(index + 1)}
                              className={currentPage === index + 1 ? 'active' : ''}
                            >
                              {index + 1}
                            </button>
                          );
                        } else if (Math.abs(currentPage - (index + 1)) === 2) {
                          return <span key={index} className="dots">...</span>;
                        }
                        return null;
                      })}
                      {currentPage < totalPages && (
                        <button onClick={() => handlePageChange(currentPage + 1)} className="ltgt">&gt;</button>
                      )}
                    </>
                  )}
                  </div>
                </>
                )}
              {doctorHistory && doctorHistory.length === 0 && (
                <p>No doctor's found.</p>
              )}
              </>
            )}
          </div>
        </div>
        <div className="footer-content">
            {process.env.REACT_APP_COPYRIGHT_TEXT || "© 2025, Powered by AmarLab"}
        </div>
      </div>
    </div>
  );
}

export default DoctorHistory;
